import "./styles/index.scss";
import _ from "lodash";
import React from "react";
import ReactDOM from "react-dom";
import ReduxThunk from "redux-thunk";
import i18n from "i18next";
import i18nConfig from "./config/i18nConfig";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import moment from "moment";
import { setIsAuthenticated, setUser, setAccessToken, setUserMetadata, setUserMetadataFetched } from "./actions";
import Auth from "./helpers/Authentication/Auth";
import reducers from "./reducers/";
import Router from "./components/Router";
import { injectSpritesheet } from "./helpers/uiHelpers";

const createStoreWithMiddleware = applyMiddleware(ReduxThunk)(createStore);
const store = createStoreWithMiddleware(reducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

const isAuthenticated = Auth.isAuthenticated();
if (isAuthenticated) {
  const accessToken = Auth.getAccessToken();
  const user = Auth.getUser();
  const auth = new Auth(accessToken);

  store.dispatch(setIsAuthenticated(isAuthenticated));
  store.dispatch(setAccessToken(accessToken));
  store.dispatch(setUser(user));

  auth.getUserMetadata(user.sub, (err, userInfos) => {
    if (userInfos) {
      const filteredUserInfos = _.omit(userInfos, ["user_metadata", "identities"]);
      const userData = { ...user, ...filteredUserInfos };
      store.dispatch(setUser(userData));

      if (userInfos.user_metadata) {
        store.dispatch(setUserMetadata(userInfos.user_metadata));
      }
    }

    store.dispatch(setUserMetadataFetched());
  });
}

injectSpritesheet("/static/icons.svg");

i18n.init(i18nConfig, () => {
  moment.locale(i18nConfig.lng);
  ReactDOM.render(
    <Provider store={store}>
      <Router />
    </Provider>,
    document.getElementById("app")
  );
});



// WEBPACK FOOTER //
// ./src/index.js